// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-family: 'Nunito Sans', Sans-serif, serif;
}

.careers-header {
    width: 55%;
    margin: auto;
}

.careers-header h1 {
    text-align: center;
}

.careers-header h1 span {
    color: #1976D2;
}

.careers-header p {
    text-align: center;
}

.carers-body {
    width: 75%;
    margin: auto;
}

.careers-note {
    display: flex;
    border-radius: 10px;
    justify-content: center;
    background-color: #E0E0E0;
}

.careers-note p span {
    font-weight: bold;
}

.careers-note p {
    margin: 10px;
    font-size: 18px;
}

.job-card {
    margin: 20px 0;
    padding: 10px 50px;
    border-radius: 10px;
    border: 1px solid #BDBDBD;
    box-shadow: 0 2px 6px 0 #0000001F;
}

.job-header {
    display: flex;
    justify-content: center;
}

.job-image {
    width: 55px;
    height: 55px;
    margin: 20px;
    display: flex;
    border-radius: 100%;
    align-items: center;
    justify-content: center;
    background-color: #1976D2;
}

.job-title {
    width: 75%;
}

.job-title h2 {
    margin-bottom: 10px;
    font-weight: normal;
}

.job-title p {
    margin-top: 10px;
    font-size: 14px;
}

.skills {
    display: flex;
}

.skills p {
    font-size: 16px;
    margin: 10px 30px;
}

.show-more {
    display: flex;
    color: #1976D2;
    cursor: pointer;
    margin-left: auto;
    width: fit-content;
}

.job-description {
    margin: 20px;
    padding: 10px 30px;
    border-radius: 10px;
    border: 1px solid #BDBDBD;
}

.no-jobs-available {
    height: 80vh;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
}

@media only screen and (max-width: 600px) {
    .careers-header {
        width: 85%;
    }

    .carers-body {
        width: 90%;
    }

    .careers-header h1 {
        font-size: 26px;
    }

    .careers-note p {
        font-size: 16px;
    }

    .job-card {
        padding: 10px;
    }

    .job-title {
        width: 85%;
    }

    .job-image {
        width: 40px;
        height: 40px;
        margin: 10px;
    }

    .job-title h2 {
        margin-top: 10px;
        margin-bottom: 5px;
    }

    .skills p {
        margin: 10px;
    }

    .job-image img {
        width: 30px;
    }

    .show-more {
        margin: 0;
        align-items: center;
    }

    .skills {
        margin: 0 10px;
    }

    .job-description h3 {
        margin-top: 5px;
    }

    .job-description {
        margin: 20px 0;
        padding: 10px 20px;
        border-radius: 20px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/careers-page/css/careers.css"],"names":[],"mappings":"AAAA;IACI,6CAA6C;AACjD;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,SAAS;QACT,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,mBAAmB;IACvB;AACJ","sourcesContent":["body {\n    font-family: 'Nunito Sans', Sans-serif, serif;\n}\n\n.careers-header {\n    width: 55%;\n    margin: auto;\n}\n\n.careers-header h1 {\n    text-align: center;\n}\n\n.careers-header h1 span {\n    color: #1976D2;\n}\n\n.careers-header p {\n    text-align: center;\n}\n\n.carers-body {\n    width: 75%;\n    margin: auto;\n}\n\n.careers-note {\n    display: flex;\n    border-radius: 10px;\n    justify-content: center;\n    background-color: #E0E0E0;\n}\n\n.careers-note p span {\n    font-weight: bold;\n}\n\n.careers-note p {\n    margin: 10px;\n    font-size: 18px;\n}\n\n.job-card {\n    margin: 20px 0;\n    padding: 10px 50px;\n    border-radius: 10px;\n    border: 1px solid #BDBDBD;\n    box-shadow: 0 2px 6px 0 #0000001F;\n}\n\n.job-header {\n    display: flex;\n    justify-content: center;\n}\n\n.job-image {\n    width: 55px;\n    height: 55px;\n    margin: 20px;\n    display: flex;\n    border-radius: 100%;\n    align-items: center;\n    justify-content: center;\n    background-color: #1976D2;\n}\n\n.job-title {\n    width: 75%;\n}\n\n.job-title h2 {\n    margin-bottom: 10px;\n    font-weight: normal;\n}\n\n.job-title p {\n    margin-top: 10px;\n    font-size: 14px;\n}\n\n.skills {\n    display: flex;\n}\n\n.skills p {\n    font-size: 16px;\n    margin: 10px 30px;\n}\n\n.show-more {\n    display: flex;\n    color: #1976D2;\n    cursor: pointer;\n    margin-left: auto;\n    width: fit-content;\n}\n\n.job-description {\n    margin: 20px;\n    padding: 10px 30px;\n    border-radius: 10px;\n    border: 1px solid #BDBDBD;\n}\n\n.no-jobs-available {\n    height: 80vh;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n}\n\n@media only screen and (max-width: 600px) {\n    .careers-header {\n        width: 85%;\n    }\n\n    .carers-body {\n        width: 90%;\n    }\n\n    .careers-header h1 {\n        font-size: 26px;\n    }\n\n    .careers-note p {\n        font-size: 16px;\n    }\n\n    .job-card {\n        padding: 10px;\n    }\n\n    .job-title {\n        width: 85%;\n    }\n\n    .job-image {\n        width: 40px;\n        height: 40px;\n        margin: 10px;\n    }\n\n    .job-title h2 {\n        margin-top: 10px;\n        margin-bottom: 5px;\n    }\n\n    .skills p {\n        margin: 10px;\n    }\n\n    .job-image img {\n        width: 30px;\n    }\n\n    .show-more {\n        margin: 0;\n        align-items: center;\n    }\n\n    .skills {\n        margin: 0 10px;\n    }\n\n    .job-description h3 {\n        margin-top: 5px;\n    }\n\n    .job-description {\n        margin: 20px 0;\n        padding: 10px 20px;\n        border-radius: 20px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
